import {Component, OnDestroy, OnInit, Type} from '@angular/core';
import {MatDialogConfig, MatDialogRef} from '@angular/material/dialog';
import {Subscription} from 'rxjs';
import {ApiwrapperService} from "../../services/apiwrapper.service";
import {DataManipulationService} from "../../services/data-manipulation.service";
import {ModalService} from "../../services/modal.service";
import {ModalWrapperComponent} from "../modal-wrapper/modal-wrapper.component";
import {CreateWorkspaceModalComponent} from "./create-workspace-modal/create-workspace-modal.component";
import {InviteMembersModalComponent} from "./invite-members-modal/invite-members-modal.component";
import {CreateTeamModalComponent} from "./create-team-modal/create-team-modal.component";
import {OrganizeTeamsModalComponent} from "./organize-teams-modal/organize-teams-modal.component";
import {FeedbackLoopModalComponent} from "./feedback-loop-modal/feedback-loop-modal.component";
import {WorkspaceUpgradeModalComponent} from "./workspace-upgrade-modal/workspace-upgrade-modal.component";
import {WorkspaceUpgradedModalComponent} from "./workspace-upgraded-modal/workspace-upgraded-modal.component";
import {RoleRequestModalComponent} from "./role-request-modal/role-request-modal.component";

const CONTENT_MODAL_CLASSES = ['generic-modal', 'content-modal'];

@Component({
  selector: 'app-modals',
  templateUrl: './modals.component.html',
  styleUrls: ['./modals.component.scss']
})
// @ts-ignore
export class ModalsComponent implements OnInit, OnDestroy {
  private openedModals = new Map<Type<unknown>, MatDialogRef<ModalWrapperComponent>>();
  private organizeTeamsSubscription: Subscription | undefined;

  constructor(public apiwrapper: ApiwrapperService, public data: DataManipulationService,
              private modalService: ModalService) { }

  ngOnInit(): void {
    this.loadWorkspaceRoles();
    this.organizeTeamsSubscription = this.data.gotOrganizeTeamsSubs.subscribe((gotTeams: any) => {
      if (gotTeams) {
        this.openOrganizerModal();
      }
    });
  }

  ngOnDestroy(): void {
    this.organizeTeamsSubscription?.unsubscribe();
  }

  openCreateWorkspaceModal() {
    this.openModal(CreateWorkspaceModalComponent, {panelClass: CONTENT_MODAL_CLASSES, width: '800px', maxWidth: '95vw'});
  }

  openMemberModal() {
    this.data.getWorkspaceInv();
    // set workspace invitation
    // @ts-ignore
    let workspace = JSON.parse(localStorage.getItem('WORKSPACE'));
    this.data.inviteMessage = workspace.activeInvitationBody.body;
    this.openModal(InviteMembersModalComponent, {panelClass: CONTENT_MODAL_CLASSES, width: '800px', maxWidth: '95vw'});
    setTimeout(() => {
      // @ts-ignore
      if(document.getElementById(`inviteEmail`) !== null) {
        document.getElementById(`inviteEmail`)?.focus();
      }
    }, 500)
  }

  openTeamModal() {
    this.openModal(CreateTeamModalComponent, {panelClass: CONTENT_MODAL_CLASSES, width: '800px', maxWidth: '95vw'});
  }

  openOrganizerModal() {
    this.openModal(OrganizeTeamsModalComponent, {
      panelClass: CONTENT_MODAL_CLASSES,
      width: '98vw',
      maxWidth: '98vw',
      height: '95vh'
    })?.afterClosed().subscribe(() => this.data.goToTeamCreated());
  }

  openCollectorModal() {
    const isEdit = !!this.data.editCollector;
    this.openModal(FeedbackLoopModalComponent, {
      panelClass: ['generic-modal', 'collector-settings-modal', ...(isEdit ? ['collector-settings-modal--edit'] : [])],
      maxWidth: isEdit ? '960px' : '85vw',
      width: isEdit ? '920px' : '80vw',
      restoreFocus: false
    });
  }

  openWorkspaceUpgradeModal() {
    this.openModal(WorkspaceUpgradeModalComponent, {panelClass: CONTENT_MODAL_CLASSES, width: '1140px', maxWidth: '95vw'});
  }

  openUpgradeWorkspaceModal() {
    this.openModal(WorkspaceUpgradedModalComponent, {panelClass: CONTENT_MODAL_CLASSES, width: '1140px', maxWidth: '95vw'});
  }

  openAdminRequestModal() {
    // @ts-ignore
    let creator = JSON.parse(localStorage.getItem('WORKSPACE')).creator;
    if (creator.avatar !== null) {
      this.data.workspaceCreatorImage = creator.avatar.path;
    }
    this.data.workspaceOwnerName = creator.detail.firstname;
    this.openModal(RoleRequestModalComponent, {panelClass: CONTENT_MODAL_CLASSES, width: '500px', maxWidth: '95vw'});
  }

  private openModal<C>(component: Type<C>, config: Omit<MatDialogConfig, 'data'>): MatDialogRef<ModalWrapperComponent> | null {
    if (this.openedModals.has(component)) {
      return null;
    }
    const dialogRef = this.modalService.openModal(component, {}, {disableClose: true, ...config});
    this.openedModals.set(component, dialogRef);
    dialogRef.afterClosed().subscribe(() => this.openedModals.delete(component));
    return dialogRef;
  }

  private loadWorkspaceRoles() {
    this.apiwrapper.getAllRoles('workspace').subscribe(
      res => {
        res.forEach((el: { name: string; uuid: any; }) => {
          if (el.name === 'workspace-admin') {
            this.data.roleWorkspaceAdmin = el.uuid;
          }
          if (el.name === 'workspace-member') {
            this.data.roleWorkspaceMember = el.uuid;
          }
        });
      }, err => {
        console.log(err);
      });
  }
}
